import React from 'react'

const Countrieslist = () => {
    return (
        <div>
            
            <ul className="gridcountries">
                <li>india</li>
                <li>australia</li>
                <li>germany</li>
                <li>africa</li>
                <li>america</li>
                <li>switzerland</li>
                <li>india</li>
                <li>australia</li>
                <li>germany</li><li>america</li>
                <li>switzerland</li>
                <li>india</li>
                <li>australia</li>
                <li>germany</li>
                <li>africa</li>
                <li>america</li>
                <li>switzerland</li>
            </ul>
       
        </div>
    )
}

export default Countrieslist
